import React, { useState } from 'react';
import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import ActionModal from 'components/common/modals/ActionModal';
import { ModalType } from 'global/utils/ModalsHelper';
import { observer } from 'mobx-react-lite';
import { FileUpload } from '@insurancemenu/imenu-components-lib';
import { UPLOAD_FILE_TYPES } from '@insurancemenu/imenu-components-lib/dist/components/FileUpload';
import { useInitialSeedProductTemplatesStore } from 'store/pages/rfq/rfq-template/initial-seed-product-templates/pageStore';
import { FileUploadStyled } from './styles';

const UploadJsonModal: React.FC = observer(() => {
  const { uploadJsonModalDelegate, setIsLoading, getInitialData } = useInitialSeedProductTemplatesStore();

  const [files, setFiles] = useState<AcceptedFiles>({});

  const onFileUpload = async (): Promise<void> => {
    await uploadJsonModalDelegate.uploadJsonFile(files);
    uploadJsonModalDelegate.close();
    setIsLoading(true);

    setTimeout(() => {
      void getInitialData();
    }, 4000);
  };

  return (
    <ActionModal
      show={uploadJsonModalDelegate.isVisible}
      title="Upload File"
      subtitle="Upload JSONs file to generate a product templates"
      modalType={ModalType.NO_ICON}
      closeButtonText="Cancel"
      onClose={uploadJsonModalDelegate.close}
      actionButtonText="Upload File"
      onAction={onFileUpload}
      loading={uploadJsonModalDelegate.isLoading}
      modalContent={
        <FileUploadStyled>
          <FileUpload
            fileMimeTypes={[UPLOAD_FILE_TYPES.json]}
            messageForRejectedFiles="Please upload only json file"
            shouldBeReset={uploadJsonModalDelegate.isFileUploadReset}
            onChange={setFiles}
          />
        </FileUploadStyled>
      }
      isValid={Object.keys(files).length !== 0}
    />
  );
});

export default UploadJsonModal;
